export default class Config {
    public apiUrl = '';
    public redirectUrl = '';
    public oidcUrl = '';
    public oidcLogoutUrl = '';

    /**
     * @param {any} model - It is possible to pass an object to the constructor.
     * If the proper attributes are filled and exist, the constructor will set up the
     * new instance with the provided values.
     */
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.apiUrl) {
            this.apiUrl = model.apiUrl;
        }
        if (model.oidcUrl) {
            this.oidcUrl = model.oidcUrl;
        }
        if (model.oidcLogoutUrl) {
            this.oidcLogoutUrl = model.oidcLogoutUrl;
        }
        if (model.redirectUrl) {
            this.redirectUrl = model.redirectUrl;
        }
    }
}
